import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MutualModule } from '@shared/mutual/mutual.module';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordInputComponent } from '@shared/password-input/components';

@NgModule({
  declarations: [PasswordInputComponent],
  imports: [CommonModule, MutualModule, TranslateModule],
  exports: [PasswordInputComponent],
})
export class PasswordInputModule {}
